export const CART_UPDATED_EVENT = 'maznut:cart-updated';

export function notifyCartUpdated(appName: string, count?: number): void {
  window.dispatchEvent(
    new CustomEvent(CART_UPDATED_EVENT, { detail: { appName, count } })
  );
}
